import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import './AtomPill.scss';
import atomImg from '../../static/img/atom.svg';

class AtomPill extends Component {
  render() {
    let label;
    if (this.props.label) {
      label = <span className="atom-pill-label">{this.props.label}</span>;
    }

    const classNames = ['atom-pill'];
    if (this.props.onClick) {
      classNames.push('clickable');
    }

    return (
      <div
        className={classNames.join(' ')}
        onClick={() => {
          if (this.props.onClick) {
            this.props.onClick();
          }
        }}
      >
        <img src={atomImg} alt={this.props.altText || 'Einstein Atom'} />
        {label}
      </div>
    );
  }
}

AtomPill.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  altText: PropTypes.string,
  intl: intlShape.isRequired
};

export default injectIntl(AtomPill);
